<template>
  <div id="flow-layer">
    <header>
      <div class="header-center">
        <a href="https://www.yuanquanyun.com.cn/"><svg-icon class="logo" iconClass="logo" />
        </a>
        <!-- <span class="logo-text">元全云电子合同</span> -->
        <span class="logo-s-title"></span>
        <a href="javascript:;" @click="returnIndex" class="return-index">
          < 返回首页 </a>
      </div>
    </header>
    <div class="flow-content">
      <div class="flow-nav clearfix">
        <div class="flow-nav-layer clearfix" ref="flowNav" id="flowNav">
          <a href="javascript:;" v-show="userInfo.idCard" @click="changeCompanySpace({}, true)"
            :class="{ active: !currentSpace.companyId }">个人空间</a>
          <a href="javascript:;" :class="{ active: currentSpace.companyId == company.companyId }"
            @click="changeCompanySpace(company, company.isAuthed)" v-for="company in companyList" :key="company.companyId"
            v-if="company.userCompanyStatus == '0' && company.isAuthed == '1'">{{ company.companyName }}</a>
        </div>
      </div>

      <div class="flow-files">
        <h3 class="flow-title">添加文件和签约方</h3>
        <div class="flow-upload">
          <ul class="el-upload-list el-upload-list--picture-card" v-if="isEdit">
            <li tabindex="0" class="el-upload-list__item is-success">
              <div data-v-0aca0cd4="">
                <img data-v-0aca0cd4="" :src="defaultPDF" alt="" class="el-upload-list__item-thumbnail">
                <span data-v-0aca0cd4="" class="el-upload-list__item-actions">
                  <span data-v-0aca0cd4="" class="el-upload-list__item-preview" @click="handleFilePreview()">
                    <i data-v-0aca0cd4="" class="el-icon-zoom-in"></i>
                  </span>

                  <span data-v-0aca0cd4="" class="el-upload-list__item-delete" @click="handleRemove()">
                    <i data-v-0aca0cd4="" class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </li>
          </ul>
          <el-upload ref="upload" :action="contractUploadUrl" :headers="myHeaders" list-type="picture-card"
            :on-success="handleFileSuccess" :on-error="handleFileError" :before-upload="handleContractBeforeUpload">
            <i slot="default" class="el-icon-plus"></i>
            <div class="upload-tip">上传合同</div>
            <div slot="file" slot-scope="{file}" v-loading="uploadLoading" element-loading-text="文件上传中……">
              <img class="el-upload-list__item-thumbnail" :src="defaultPDF" alt="">
              <span class="el-upload-list__item-actions">
                <span class="el-upload-list__item-preview" @click="handleFilePreview(file)">
                  <i class="el-icon-zoom-in"></i>
                </span>

                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog :append-to-body="true" :visible.sync="dialogVisible">
            <img v-for="(img, index) in pngList" :key="index" width="100%" :src="img" alt="">
          </el-dialog>

        </div>
        <p class="upload-tip2" v-if="!contractFileOk">仅支持PDF文件合同，合同文件大小 < 20M</p>
            <p class="upload-tip2" style="color: #30bf77;" v-else>文件上传成功！</p>
            <div class="upload-progress clearfix" v-show="percentage > 0 && percentage < 100">
              <div class="progress-box">
                <el-progress :percentage="percentage"></el-progress>
              </div>
            </div>
            <div class="files-form-box">
              <el-form :model="filesForm" :rules="filesRules" ref="filesForm" label-width="100px" class="files-Form">
                <el-form-item prop="cname" label="合同名称" :rules="[
                  { required: true, message: '请输入合同名称', trigger: 'blur' },
                  { validator: checkContractName, trigger: 'blur' }
                ]">
                  <el-input maxlength="50" v-model="filesForm.cname"></el-input>
                </el-form-item>
                <el-form-item prop="ctype" label="合同类型" :rules="[
                  { required: currentSpace.companyId, message: '请选择合同类型', trigger: 'change' }
                ]" v-if="currentSpace.companyId">
                  <el-select v-model="filesForm.ctype" clearable placeholder="合同类型" style="width: 220px">
                    <el-option v-for="item in contractTypes" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item prop="cdate" label="签署截止日" :rules="[
                  { required: true, message: '请选择签署截止日', trigger: 'blur' }
                ]">
                  <el-date-picker style="width: 220px;" v-model="filesForm.cdate" type="date"
                    :picker-options="pickerOptions" value-format="yyyy-MM-dd hh:mm:ss">
                  </el-date-picker>
                </el-form-item>
              </el-form>
            </div>


      </div>

      <div class="flow-users-box">
        <div class="add-user-btns">
          <el-button icon="el-icon-plus" @click="addSignatory(1)" class="add-btn">添加企业</el-button>
          <el-button icon="el-icon-plus" @click="addSignatory(0)" class="add-btn">添加个人</el-button>
          <el-button icon="el-icon-plus" :disabled="isBatch === 1 || isBatch === 0 || isBatchOk" @click="batchHandle(1)"
            class="add-btn">批量导入企业</el-button>
          <el-button icon="el-icon-plus" :disabled="isBatch === 1 || isBatch === 0 || isBatchOk" @click="batchHandle(0)"
            class="add-btn">批量导入个人</el-button>
        </div>

        <div class="signatory-list">
          <div class="signatory-item" v-for="sign in signatoryList" :key="sign.sequence">
            <h3 class="signatory-item-title">
              签约方-{{ sign.signingBody === 0 ? '个人' : '企业' }}
              <img :src="isAuthedImg[sign.isAuth]" v-if="sign.signingBody === 0"
                style="position: relative; top: 6px; left: 2px;" />
            </h3>
            <div class="signatory-form clearfix">
              <div class="signatory-form-item" v-if="sign.signingBody === 0">
                <div class="signatory-form-item-title">手机号</div>
                <div class="signatory-form-item-inp">
                  <img class="mail-icon" @click="showContactHandle(sign)" src="../../assets/images/sign/mail-icon.png"
                    alt="">
                  <el-input @blur="getUserHandle(sign)" maxlength="11" v-model="sign.phonenumber" />
                </div>
              </div>

              <div class="signatory-form-item" v-if="sign.signingBody === 0">
                <div class="signatory-form-item-title">姓名</div>
                <div class="signatory-form-item-inp">
                  <el-input maxlength="30" @blur="getUserHandle(sign)" v-model="sign.subjectName" />
                </div>
              </div>

              <div class="signatory-form-item" v-if="sign.signingBody === 0 && sign.authAccounts.length > 1">
                <div class="signatory-form-item-title">账号</div>
                <div class="signatory-form-item-inp">
                  <el-select v-model="sign.account" placeholder="请选择">
                    <el-option v-for="item in sign.authAccounts" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="signatory-form-item" v-if="sign.signingBody === 1">
                <div class="signatory-form-item-title">账号</div>
                <div class="signatory-form-item-inp">
                  <img class="mail-icon" @click="showContactHandle(sign)" src="../../assets/images/sign/mail-icon.png"
                    alt="">
                  <el-input @blur="getAccountInfoHandle(sign.account, sign.sequence, sign.signingBody)" maxlength="14"
                    v-model="sign.account" />
                </div>
              </div>

              <div class="signatory-form-item" v-if="sign.signingBody === 1">
                <div class="signatory-form-item-title">{{ sign.signingBody === 0 ? '姓名' : '企业名称' }}</div>
                <div class="signatory-form-item-inp">
                  <el-input maxlength="30" v-model="sign.subjectName" />
                </div>
              </div>

              <div class="signatory-form-item" v-if="sign.signingBody === 1">
                <div class="signatory-form-item-title">经办人账号</div>
                <div class="signatory-form-item-inp">
                  <el-input @blur="validateContactAgentUserHandle(sign)" maxlength="14" v-model="sign.agentAccount" />
                </div>
              </div>
              <div class="signatory-form-item" v-if="sign.signingBody === 1">
                <div class="signatory-form-item-title">经办人姓名</div>
                <div class="signatory-form-item-inp">
                  <el-input maxlength="30" v-model="sign.agentName" />
                </div>
              </div>
            </div>
            <img src="../../assets/images/sign/delete.png" @click="deleteSignatory(sign.sequence)"
              class="signatory-delete" alt="">
          </div>

          <div class="signatory-batch" v-show="isBatch === 1 || isBatch === 0 && isBatchOk == false">
            <h3 class="signatory-item-title">签约方-批量{{ isBatch === 0 ? '个人' : '企业' }}</h3>
            <div class="signatory-batch-content">
              <div class="signatory-batch-item clearfix">
                <span class="step">1</span>
                <div class="step-cont">
                  下载 <a class="download-template" @click="downloadTemplateHandle" href="javascript:;">《批量导入{{ isBatch ===
                    0
                    ? '个人' : '企业' }}模板》</a>
                </div>
              </div>
              <div class="signatory-batch-item clearfix">
                <span class="step">2</span>
                <div class="step-cont">
                  <span style="float: left;">点此处上传</span>
                  <div class="upload-template">
                    <el-upload class="upload-demo" :data="{ 'templateType': isBatch === 0 ? 'gr' : 'qy' }"
                      :file-list="tempList" :action="templateUploadUrl" :headers="myHeaders"
                      :on-success="uploadTemplateSuccess">
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                  </div>
                  <!-- <el-button class="upload-template">上传</el-button> -->
                </div>
              </div>
              <div class="signatory-batch-item clearfix">
                <span class="step">3</span>
                <div class="step-cont">
                  检查核对签约方信息
                </div>
              </div>
            </div>
            <img @click="deleteBatchSignatory" src="../../assets/images/sign/delete.png" class="signatory-delete" alt="">
          </div>

          <div class="signatory-batch-success" v-show="isBatchOk">
            <h3 class="signatory-item-title">签约方-批量{{ batchType === 0 ? '个人' : '企业' }}</h3>
            <div class="signatory-batch-content2">
              <div class="signatory-batch-text">
                {{ batchMsg }}
              </div>
              <div class="signatory-batch-text">
                <div style="float: left;">
                  <a href="javascript:;" @click="showBatchSignatory" class="show-signatory">点此查看</a>
                  <span>签约方信息 或</span>
                </div>
                <div class="upload-template">
                  <el-upload class="upload-demo" ref="tempupload"
                    :data="{ 'templateType': batchType === 0 ? 'gr' : 'qy' }" :file-list="tempList"
                    :before-upload="tempBeforeHandle" :on-success="uploadTemplateSuccess" :on-change="tempChangeHandle"
                    :action="templateUploadUrl" :headers="myHeaders">
                    <el-button size="small" type="primary">重新上传</el-button>
                  </el-upload>
                </div>
              </div>
            </div>
            <img @click="deleteBatchSignatory" src="../../assets/images/sign/delete.png" class="signatory-delete" alt="">
          </div>
        </div>

        <div class="sign-btns">
          <el-button class="sign-button" @click="contractHandle('start')">指定签署位置</el-button>
          <el-button :disabled="isDraftOk" @click="contractHandle('edit')">保存草稿</el-button>
        </div>
      </div>

    </div>
    <template-list ref="temp" @saveBatch="saveBatchHandle"></template-list>
    <contact-user-list ref="contractUser" @selectSignatory="selectSignatoryHandle"></contact-user-list>
    <contact-company-list ref="contractCompany" @selectSignatory="selectSignatoryHandle"></contact-company-list>
  </div>
</template>
<script>
import {
  Loading
} from 'element-ui';
import eHeader from '@/components/eHeader'
import {
  getToken
} from '@/utils/auth'
import {
  getContractImgsApi,
  contractEditApi,
  getContractInfoApi,
  getAccountInfoApi,
  downloadTemplateApi,
  getContractTypeApi,
  validateContactAgentUserApi,
  getContractSignListApi,
  getUserApi
} from '@/api/sign/flow'
import {
  getSignatoryListApi
} from '@/api/sign/set-control'
import moment from 'moment'
import {
  mapState
} from 'vuex'
import contactUserList from './contact-user-list'
import contactCompanyList from './contact-company-list'
import templateList from './template-list'
import { parseTime, downloadFile } from '@/utils/index'
export default {
  components: {
    templateList,
    contactUserList,
    contactCompanyList
  },
  data() {
    // var checkContractName = (rule, value, callback) => {
    //   // var reg = new RegExp('[\\\\/:*?\"<>|]');
    //   var reg = new RegExp(
    //     '(?!((^(con)$)|^(con)/..*|(^(prn)$)|^(prn)/..*|(^(aux)$)|^(aux)/..*|(^(nul)$)|^(nul)/..*|(^(com)[1-9]$)|^(com)[1-9]/..*|(^(lpt)[1-9]$)|^(lpt)[1-9]/..*)|^/s+|.*/s$)(^[^/////:/*/?/"/</>/|]{1,50}$)'
    //     )
    //   if (!reg.test(value)) {
    //     callback(new Error('合同名不能包含下列任何字符:\/:*?"<>|'));
    //   } else {
    //     callback();
    //   }
    // }
    return {
      percentage: 0,
      isDraftOk: false,
      uploadLoading: false,
      isEdit: false,
      contractUploadUrl: ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + 'contract/upload',
      myHeaders: {
        'Authorization': getToken()
      },
      contractFileOk: false,
      defaultPDF: require('../../assets/images/sign/pdf.png'),
      isAuthedImg: [
        require('../../assets/images/sign/isAuth-2.png'),
        require('../../assets/images/sign/isAuth-1.png')
      ],
      dialogVisible: false,
      pngList: [],
      disabled: false,
      fileId: '',
      filesForm: {
        cname: '',
        cdate: '',
        ctype: ''
      },
      contractTypes: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      filesRules: {
        // cname: [{
        //     required: true,
        //     message: '请输入合同名称',
        //     trigger: 'blur'
        //   },
        //   {
        //     validator: checkContractName,
        //     trigger: 'blur'
        //   },
        // ]
        // ,
        // cdate: [{
        //   required: true,
        //   message: '请选择签署截止日',
        //   trigger: 'blur'
        // }]
        // ,
        // ctype: [
        //   { required: true, message: '请选择合同类型', trigger: 'change' }
        // ]
      },
      signatoryList: [
        // {

        //   sequence: 1, // 签署顺序
        //   signingBody: 0, // 签署主体
        //   account: "",  // 账号
        //   agentAccount: "" // 经办人账号
        //   agentName: "" // 经办人姓名
        //   companyId: ""  // 企业id
        //   subjectName: ""  // 账号认证名称
        // }
      ],
      batchSignatoryList: [],  // 单方批量
      // data: {
      //   "contractName": "01-st",
      //   "endDate": "2020-07-18",
      //   "contractId": "",
      //   "companyId": "fromolde5e3a3ecc4928266bf4ee5c38",
      //   "contractFileId": "8c0cf1f5729640dbb354af7d778b15d6",
      //   "contractTypeId": "8c0cf1f5729640dbb354af7d778b15d6",
      //   "signatoryList": [  //
      //     {
      //       companyName: "",  // 企业名称
      //       sequence: 1, // 签署顺序
      //       signingBody: 0, // 签署主体
      //       userName: "", // 姓名
      //       account: "",  // 账号
      //       agentAccount: "", // 经办人账号
      //       agentName: "" // 经办人姓名
      //     }
      //   ],
      //   "batchSignatoryList": [ // 单方批量，sequence是相同的
      //     {
      //       companyName: "",  // 企业名称
      //       sequence: 1, // 签署顺序
      //       signingBody: 0, // 签署主体
      //       userName: "", // 姓名
      //       account: "",  // 账号
      //       agentAccount: "", // 经办人账号
      //       agentName: "" // 经办人姓名
      //     },
      //     {
      //       companyName: "",  // 企业名称
      //       sequence: 1, // 签署顺序
      //       signingBody: 0, // 签署主体
      //       userName: "", // 姓名
      //       account: "",  // 账号
      //       agentAccount: "", // 经办人账号
      //       agentName: "" // 经办人姓名
      //     },
      //   ]
      // },
      // batchSigningBody: 1, // 0 批量个人 1 批量企业
      templateUploadUrl: ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + 'contract/saveFormwork',
      tempList: [],
      isBatch: "", // 0 批量个人 1 批量企业
      isBatchOk: false,
      batchMsg: '',
      isDraftOk: false,
      batchType: 0
    }
  },
  computed: mapState([
    'companyList',
    'currentSpace',
    'userInfo'
  ]),
  created() {
    if (this.$route.query.contractId) {
      this.getSignatoryListHandle()
      this.getContractInfoHandle()
      this.contractFileOk = true
    }
    this.getContractTypeHandle()
  },
  methods: {
    getContractInfoHandle() {
      getContractInfoApi(this.$route.query.contractId).then(res => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.filesForm.cname = res.data.contractName
          this.filesForm.cdate = moment(res.data.endDate).format("YYYY-MM-DD hh:mm:ss")
          this.filesForm.ctype = res.data.contractTypeId
          if (this.filesForm.cname) {
            this.isEdit = true
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getSignatoryListHandle() {
      getContractSignListApi({
        contractId: this.$route.query.contractId,
        nocache: new Date().getTime()
      }).then(res => {
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.signatoryList = res.data.signatoryList
          this.batchSignatoryList = res.data.batchSignatoryList
          if (this.batchSignatoryList.length > 0) {
            this.isBatchOk = true
            this.$refs.temp.templateData = res.data.batchSignatoryList
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    checkContractName(rule, value, callback) {
      var reg = new RegExp(
        '(?!((^(con)$)|^(con)/..*|(^(prn)$)|^(prn)/..*|(^(aux)$)|^(aux)/..*|(^(nul)$)|^(nul)/..*|(^(com)[1-9]$)|^(com)[1-9]/..*|(^(lpt)[1-9]$)|^(lpt)[1-9]/..*)|^/s+|.*/s$)(^[^/////:/*/?/"/</>/|]{1,50}$)'
      )
      if (!reg.test(value)) {
        callback(new Error('合同名不能包含下列任何字符:\/:*?"<>|'));
      } else {
        callback();
      }
    },
    getContractTypeHandle() {
      getContractTypeApi(this.currentSpace.companyId).then(res => {
        if (res.code != '0') {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.contractTypes = res.data
        }
      })
    },
    returnIndex() {
      this.$confirm('是否保存草稿', '温馨提示', {
        confirmButtonText: '保存草稿',
        cancelButtonText: '返回首页',
        distinguishCancelAndClose: true,
        type: 'warning',
        center: true,
        showClose: false
      }).then(() => {
        this.contractHandle('edit')
      }).catch((action) => {
        if (action === 'cancel') {
          this.$router.push('/')
        }
      });
    },
    handleFileSuccess(response, file, fileList) {
      if (response.code !== '0') {
        this.$message({
          showClose: true,
          message: response.message,
          type: 'warning'
        });
        // this.defaultPDF = ''
        this.$refs.upload.clearFiles();
        this.isEdit = false
        this.fileId = ''
        this.uploadLoading = false
      } else {
        // this.defaultPDF =
        this.fileId = response.result.fileId
        this.filesForm.cname = file.name.substring(0, file.name.lastIndexOf('.'))
        this.isUpload = true
        this.uploadLoading = false
        var uploadTimer = null;
        var progressTimer = null;
        uploadTimer = setInterval(() => {
          this.percentage += 2
          if (this.percentage >= 99) {
            this.percentage = 99
            clearInterval(uploadTimer)

            progressTimer = setInterval(() => {
              getContractImgsApi(this.fileId || this.$route.query.contractId).then(res => {
                if (res.code == '0') {
                  this.percentage = 100
                  this.contractFileOk = true
                  clearInterval(progressTimer)
                }
              }).catch(err => {
                console.log(err)
              })
            }, 1000)
          }
        }, 60)
      }
    },
    handleFileError(err, file, fileList) {
      console.log(err)
      this.$message({
        showClose: true,
        message: '文件上传失败！',
        type: 'warning'
      });
    },
    handleContractBeforeUpload(file) {
      if (file.type != 'application/pdf') {
        this.$refs.upload.clearFiles();
        this.$message.warning(`请上传pdf类型文件！`);
        return false
      } else {
        if (file.size > 20 * 1024 * 1024) {
          this.$message.warning(`文件大小超出20M限制，请重新上传！`);
          return false
        } else {
          this.uploadLoading = true
        }
      }
    },
    handleFilePreview(file) { // 查看上传文件
      this.getContractImgsHandle().then(data => {
        this.pngList = data.map(el => {
          return (((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + el + getToken() + '&nocache=' + new Date().getTime())
        })
        this.dialogVisible = true;
      })
    },
    handleRemove(file) {
      this.$refs.upload.clearFiles();
      this.contractFileOk = false
      this.isEdit = false
      this.fileId = ''
      this.percentage = 0
    },
    changeCompanySpace(company, isAuthed) {
      if (isAuthed == '3') {
        this.$confirm('该企业还未进行实名认证，请先认证。', '温馨提示', {
          confirmButtonText: '立即认证',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          showClose: false
        }).then(() => {
          this.$router.push({
            path: '/company-auth-info',
            query: {
              companyId: company.companyId,
              companyName: company.companyName
            }
          })
        }).catch(() => {

        });
      } else if (isAuthed == '2') {
        this.$confirm('该企业实名认证未通过，请重新认证。', '温馨提示', {
          confirmButtonText: '重新认证',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          showClose: false
        }).then(() => {
          this.$router.push({
            path: '/company-auth-info',
            query: {
              companyId: company.companyId,
              companyName: company.companyName
            }
          })
        }).catch(() => {

        });
      } else if (isAuthed == '0') {
        this.$message.warning('企业认证中不能操作')
      } else {
        this.$confirm('你确定要切换空间吗？切换后，已填写信息将会被清空', '切换空间', {
          confirmButtonText: '切换空间',
          cancelButtonText: '取消',
          type: 'warning',
          center: true,
          showClose: false
        }).then(() => {
          this.$store.commit('SET_CURRENT_SPACE', company)

          // window.location.href = window.location.href.substring(0, window.location.href.indexOf('?'));

          this.fileId = ''
          this.percentage = 0
          this.$refs.upload.clearFiles();
          this.isEdit = false
          this.filesForm.cname = ''
          this.filesForm.cdate = ''
          this.filesForm.ctype = ''
          this.signatoryList = []
          this.batchSignatoryList = []
          this.contractFileOk = false
          this.isBatch = ''
          this.isBatchOk = false
          this.$router.push('/flow')
          this.getContractTypeHandle()
          this.$refs['filesForm'].resetFields();
        }).catch(() => {

        });
      }

    },
    getContractImgsHandle() {
      return new Promise((resolve, reject) => {
        getContractImgsApi(this.fileId || this.$route.query.contractId).then(res => {
          console.log(res)
          if (res.code !== 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: 'warning'
            });
          } else {
            resolve(res.data.pngList)
          }
        }).catch(err => {
          console.log(err)
        })
      })

    },
    addSignatory(signingBody) {
      var sequence = 0;
      if (this.batchSignatoryList.length > 0) {
        sequence = this.signatoryList.length + 2
      } else {
        sequence = this.signatoryList.length + 1
      }
      this.signatoryList.push({
        sequence: sequence,
        subjectName: "",
        signingBody: signingBody,
        phonenumber: "",
        account: "",
        agentAccount: "",
        agentName: "",
        agentList: [],
        companyId: '',
        isAuth: '0',
        authAccounts: []
      })
    },
    getUserHandle(signing) {
      var reg = /^1[3456789]\d{9}$/;
      // if (signing.phonenumber == '') {
      //   this.$message({
      //     showClose: true,
      //     message: '手机号不能为空！',
      //     type: 'warning'
      //   });

      //   return
      // }

      if (!reg.test(signing.phonenumber)) {
        this.$message({
          showClose: true,
          message: '手机号格式不正确',
          type: 'warning'
        });

        return
      }

      getUserApi({
        phonenumber: signing.phonenumber,
        nickName: signing.subjectName
      }).then(res => {
        console.log(res)
        if (res.code == '0') {
          signing.isAuth = res.data.isAuth
          signing.authAccounts = res.data.authAccounts
          if (signing.authAccounts.length > 1) {
            signing.account = ''
          } else {
            signing.account = signing.authAccounts[0]
          }
        } else {
          signing.isAuth = 0
          signing.authAccounts = []
          signing.account = ''
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getAccountInfoHandle(account, index, signingBody) {
      getAccountInfoApi({
        userName: account,
        nocache: new Date().getTime(),
        type: signingBody
      }).then(res => {
        if (res.code != 0) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          // res.data
          this.signatoryList.forEach(sign => {
            if (sign.sequence === index) {
              if (sign.signingBody === 0) {
                sign.subjectName = res.data.nickName
              } else {
                sign.subjectName = res.data.nickName
                sign.companyId = res.data.companyId
              }
              // if (res.data.companyId) {
              //   this.validateContactAgentUserHandle(res.data.companyId).then(res => {
              //     if (res.code != '0') {
              //       this.$message({
              //         showClose: true,
              //         message: res.message,
              //         type: 'warning'
              //       });
              //     } else {
              //       sign.agentList = res.data
              //     }
              //   })
              // }
            }
          })


        }
      }).catch(err => {
        console.log(err)
      })
    },
    showContactHandle(signData) {
      console.log(signData.signingBody)
      if (signData.signingBody == 0) {
        this.$refs.contractCompany.userType = 2
        this.$refs.contractUser.dialogVisible = true
        this.$refs.contractUser.sequence = signData.sequence
        this.$refs.contractUser.multipleSelection = []
        this.$refs.contractUser.addok = false
        this.$refs.contractUser.init()
      } else {
        this.$refs.contractCompany.userType = 1
        this.$refs.contractCompany.dialogVisible = true
        this.$refs.contractCompany.sequence = signData.sequence
        this.$refs.contractCompany.multipleSelection = []
        this.$refs.contractCompany.addok = false
        this.$refs.contractCompany.init()
      }
      // if (signData.signingBody == 0) {
      //   this.$refs.contractUser.dialogVisible = true
      //   this.$refs.contractUser.sequence = signData.sequence
      //   this.$refs.contractUser.multipleSelection = []
      //   this.$refs.contractUser.addok = false
      //   if (this.currentSpace.companyId) {
      //     this.$refs.contractCompany.userType = 1
      //   } else {
      //     this.$refs.contractCompany.userType = 2
      //   }
      //   this.$refs.contractUser.init()
      // } else {
      //   this.$refs.contractCompany.dialogVisible = true
      //   this.$refs.contractCompany.sequence = signData.sequence
      //   this.$refs.contractCompany.multipleSelection = []
      //   this.$refs.contractCompany.addok = false
      //   if (this.currentSpace.companyId) {
      //     this.$refs.contractCompany.userType = 1
      //   } else {
      //     this.$refs.contractCompany.userType = 2
      //   }
      //   this.$refs.contractCompany.init()
      // }
    },
    selectSignatoryHandle(data) {
      // this.signatoryList.push({
      //   sequence: this.signatoryList.length + 1,
      //   companyName: data.companyName || '',
      //   signingBody: data.companyName ? 1 : 0,
      //   userName: data.nickName || "",
      //   account: data.userName || "",
      //   agentAccount: data.agentAccount || '',
      //   agentName: data.agentName || '',
      //   companyId: data.companyId || ''
      // })

      var selectData = data.multipleSelection

      this.signatoryList.forEach((item, index) => {
        if (item.sequence === data.sequence) {  // 通过sequence判断点击的第几个签署方
          if (selectData.companyId) { // 如果companyName不为空，为企业 否则 为个人
            item.subjectName = selectData.nickName
            item.signingBody = 1
            item.account = selectData.userName
            item.agentAccount = selectData.agentUserName
            item.agentName = selectData.agentNickName
            item.companyId = selectData.companyId
          } else {
            item.subjectName = selectData.nickName
            item.account = selectData.userName
            item.phonenumber = selectData.phonenumber
            item.isAuth = 1
            this.getUserHandle(item)
          }
        }
      })

      console.log(this.data)
    },
    downloadTemplateHandle() {
      console.log(this.batchSigningBody)
      downloadTemplateApi(this.batchSigningBody).then(res => {
        console.log(res)
        downloadFile(res, '批量模板', 'xlsx')
      })
    },
    tempBeforeHandle(file) {
      // this.tempList = []
      // this.$refs.tempupload.clearFiles();
      console.log(this.tempList)
    },
    tempChangeHandle() {

    },
    uploadTemplateSuccess(response, file, fileList) {
      console.log(response)
      if (response.code !== '0') {
        this.$message({
          showClose: true,
          message: response.message,
          type: 'warning'
        });
      } else {
        //
        this.isBatchOk = true
        this.isBatch = ''
        this.batchMsg = response.result.msg
        this.batchSignatoryList = []
        let resData = []
        response.result.list.forEach(data => {
          resData.push({
            sequence: this.signatoryList.length + 1,
            signingBody: data.agentAccount ? 1 : 0,
            account: data.account,
            subjectName: data.subjectName,
            agentAccount: data.agentAccount,
            agentName: data.agentName,
            phonenumber: data.phonenumber
          })
        })
        this.batchSignatoryList = resData
        this.$refs.temp.templateData = resData
        // this.$refs.tempupload.clearFiles();
      }
    },
    showBatchSignatory() {
      this.$refs.temp.dialogVisible = true
    },
    validateContactAgentUserHandle(signData) {
      console.log(signData)
      // 通过企业id和经办人账号校验经办人
      validateContactAgentUserApi({
        agentAccount: signData.agentAccount,
        account: signData.account,
        type: 0,
        nocache: new Date().getTime()
      }).then(res => {
        console.log(res.code)
        if (res.code !== 200) {
          console.log(123)
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          signData.agentName = res.data.nickName
        }
      })
    },
    deleteSignatory(index) {
      this.signatoryList.forEach((item, i) => {
        if (item.sequence === index) {
          this.signatoryList.splice(i, 1)
        }
      })

      this.signatoryList.forEach((d, j) => {
        d.sequence = j + 1
      })
    },
    batchHandle(type) {
      this.isBatch = type
      this.batchType = type
      this.$refs.temp.templateType = type
      type === 0 ? this.batchSigningBody = 2 : this.batchSigningBody = 1
    },
    saveBatchHandle(batchData) {
      this.batchSignatoryList = batchData
    },
    deleteBatchSignatory() {
      this.isBatch = ''
      this.isBatchOk = false
      this.batchSignatoryList = []
      this.signatoryList.forEach((item, index) => {
        item.sequence = parseInt(index) + 1
      })
      console.log(this.signatoryList)
    },
    contractHandle(typestatus) {
      this.$refs.filesForm.validate((valid) => {
        if (valid) {
          var reg = /^[\u0391-\uFFE5]+$/;
          if (!this.fileId && !this.$route.query.contractId) {
            this.$message({
              showClose: true,
              message: '请上传合同！',
              type: 'warning'
            });

            return
          }

          var dateTime = new Date(this.filesForm.cdate).getTime()
          var now = new Date();
          var year = now.getFullYear();
          var month = now.getMonth();
          var date = now.getDate();
          var time = year + "-" + (month + 1) + "-" + date;
          var todayTime = new Date(time).getTime()

          if (dateTime < todayTime) {
            this.$message({
              showClose: true,
              message: '请修改截止日期！',
              type: 'warning'
            });

            return
          }

          this.getContractImgsHandle().then(data => {
            if (this.signatoryList.length > 0 || this.batchSignatoryList.length > 0) {
              let isvalid = true

              for (var i = 0; i < this.signatoryList.length; i++) {

                // if (!this.signatoryList[i].account) {
                //   this.$message({
                //     showClose: true,
                //     message: '账号不能为空！',
                //     type: 'warning'
                //   });

                //   isvalid = false
                //   break;
                // }

                if (this.signatoryList[i].signingBody == '0' && !this.signatoryList[i].subjectName) {
                  this.$message({
                    showClose: true,
                    message: '姓名不能为空！',
                    type: 'warning'
                  });

                  isvalid = false
                  break;
                }

                if (this.signatoryList[i].signingBody == '1' && !this.signatoryList[i].subjectName) {
                  this.$message({
                    showClose: true,
                    message: '企业名称不能为空！',
                    type: 'warning'
                  });

                  isvalid = false
                  break;
                }

                if (this.signatoryList[i].signingBody == '1' && !this.signatoryList[i].agentAccount) {
                  this.$message({
                    showClose: true,
                    message: '经办人账号不能为空！',
                    type: 'warning'
                  });

                  isvalid = false
                  break;
                }

                if (this.signatoryList[i].signingBody == '1' && !this.signatoryList[i].agentName) {
                  this.$message({
                    showClose: true,
                    message: '经办人姓名不能为空！',
                    type: 'warning'
                  });

                  isvalid = false
                  break;
                }

              }

              if (isvalid) {
                let signatoryList = []
                this.signatoryList.forEach(item => {
                  signatoryList.push({
                    phonenumber: item.phonenumber,
                    signingBody: item.signingBody,
                    sequence: item.sequence,
                    account: item.account,
                    subjectName: item.subjectName,
                    agentAccount: item.agentAccount,
                    agentName: item.agentName
                  })
                })

                var isFirst = false // 发起人是否是第一签署人
                var isSame = false // 第一签署人签署主体是否与当前发起空间相同
                var firstSignatory = {}
                var find = false // 校验是否有重复签署方
                for (var i = 0; i < signatoryList.length; i++) {
                  for (var j = i + 1; j < signatoryList.length; j++) {
                    if (signatoryList[i].signingBody === signatoryList[j].signingBody && signatoryList[i].account === signatoryList[j].account && signatoryList[i].subjectName === signatoryList[j].subjectName && signatoryList[i].agentAccount === signatoryList[j].agentAccount && signatoryList[i].agentName === signatoryList[j].agentName && signatoryList[i].phonenumber === signatoryList[j].phonenumber) {
                      this.$message({
                        showClose: true,
                        message: '存在重复签署方，请删除重复用户后再尝试提交！',
                        type: 'warning'
                      });

                      find = true;
                      console.log(1)
                      break

                    }

                    if (signatoryList[i].signingBody != signatoryList[j].signingBody && (signatoryList[i].account === signatoryList[j].agentAccount || signatoryList[i].agentAccount === signatoryList[j].account)) {
                      this.$message({
                        showClose: true,
                        message: '存在重复签署方，请删除重复用户后再尝试提交！',
                        type: 'warning'
                      });

                      find = true;

                      console.log(2)
                      break
                    }

                    if (signatoryList[i].signingBody === signatoryList[j].signingBody && signatoryList[i].account === signatoryList[j].account && signatoryList[j].account !== '') {
                      this.$message({
                        showClose: true,
                        message: '存在重复签署方，请删除重复用户后再尝试提交！',
                        type: 'warning'
                      });

                      find = true;

                      console.log(3)

                      break
                    }
                  }

                  if (find) break;
                }
                if (this.batchSignatoryList.length > 0) {
                  for (var i = 0; i < signatoryList.length; i++) {
                    for (var j = 0; j < this.batchSignatoryList.length; j++) {
                      if (signatoryList[i].signingBody === this.batchSignatoryList[j].signingBody && signatoryList[i].account === this.batchSignatoryList[j].account && signatoryList[i].subjectName === this.batchSignatoryList[j].subjectName && signatoryList[i].agentAccount === this.batchSignatoryList[j].agentAccount && signatoryList[i].agentName === this.batchSignatoryList[j].agentName) {
                        this.$message({
                          showClose: true,
                          message: '存在重复签署方，请删除重复用户后再尝试提交！',
                          type: 'warning'
                        });

                        find = true;

                        break

                      }

                      if (signatoryList[i].signingBody != this.batchSignatoryList[j].signingBody && (signatoryList[i].account === this.batchSignatoryList[j].agentAccount || signatoryList[i].agentAccount === this.batchSignatoryList[j].account)) {
                        this.$message({
                          showClose: true,
                          message: '存在重复签署方，请删除重复用户后再尝试提交！',
                          type: 'warning'
                        });

                        find = true;

                        break
                      }

                      if (signatoryList[i].signingBody === this.batchSignatoryList[j].signingBody && signatoryList[i].account === this.batchSignatoryList[j].account) {
                        this.$message({
                          showClose: true,
                          message: '存在重复签署方，请删除重复用户后再尝试提交！',
                          type: 'warning'
                        });

                        find = true;

                        break
                      }
                    }

                    if (find) break;
                  }
                }

                signatoryList.forEach(signatory => {
                  if (signatory.sequence == 1) {
                    console.log(signatory.account, this.userInfo.userName)
                    if (signatory.account == this.userInfo.userName && signatory.signingBody == '0') {
                      isFirst = true
                      firstSignatory = signatory
                    }

                    if (signatory.agentAccount == this.userInfo.userName && signatory.signingBody == '1') {
                      isFirst = true
                      firstSignatory = signatory
                    }

                    if (signatory.signingBody == '0') { // 签署主体是个人
                      if (!this.currentSpace.companyName) { // 当前空间是个人空间
                        isSame = true
                      } else {
                        isSame = false
                      }
                    } else {
                      if (this.currentSpace.companyName) { // 判断当前是否是企业空间
                        if (signatory.subjectName == this.currentSpace.companyName) {
                          isSame = true
                        }
                      } else {
                        isSame = false
                      }
                    }
                  }
                })

                // signatoryList.forEach(signatory => {
                //   if (signatory.sequence == 1) {
                //     if (signatory.name == this.userInfo.name && signatory.phone == this.userInfo
                //       .phone) { // 判断第一签署人是否是当前发起人
                //       isFirst = true
                //       firstSignatory = signatory
                //     }

                //     if (signatory.signingBody == '0') { // 签署主体是个人
                //       if (!this.currentSpace.companyName) { // 当前空间是个人空间
                //         isSame = true
                //       } else {
                //         isSame = false
                //       }
                //     } else { // 签署主体是企业
                //       if (this.currentSpace.companyName) { // 判断当前是否是企业空间
                //         if (signatory.companyName == this.currentSpace.companyName) {
                //           isSame = true
                //         }
                //       } else {
                //         isSame = false
                //       }

                //     }

                //   }
                // })

                // 接口
                if (typestatus == 'edit' && !find) { // 保存草稿
                  this.toPositionHandle(signatoryList, firstSignatory, typestatus, isFirst, isSame)
                } else if (typestatus == 'start' && !find) { // 发起签约
                  if (signatoryList.length > 0 || this.batchSignatoryList.length > 0) {
                    this.toPositionHandle(signatoryList, firstSignatory, typestatus, isFirst, isSame)
                  } else {
                    this.$message({
                      showClose: true,
                      message: '请添加签署方！',
                      type: 'warning'
                    });

                    return
                  }
                }

              }
            } else {
              this.$message({
                showClose: true,
                message: '请添加签署方！',
                type: 'warning'
              });
            }
          })
        }
      })
    },
    toPositionHandle(signatoryList, firstSignatory, typestatus, isFirst, isSame) {
      let loadingInstance = Loading.service({
        fullscreen: true
      });
      this.isDraftOk = true
      let batchSignatoryList = []

      this.batchSignatoryList.forEach(sign => {
        sign.sequence = signatoryList.length + 1
      })

      contractEditApi({
        contractName: this.filesForm.cname,
        endDate: moment(this.filesForm.cdate).format("YYYY-MM-DD"),
        contractId: this.$route.query.contractId || '',
        companyId: this.currentSpace.companyId || '',
        contractFileId: this.fileId,
        contractTypeId: this.filesForm.ctype,
        signatoryList,
        batchSignatoryList: this.batchSignatoryList
      }).then(res => {
        console.log(res)
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.code !== 200) {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
          this.isDraftOk = false
          return;
        } else {
          if (typestatus == 'edit') {
            this.$message({
              message: '保存草稿成功！',
              type: 'success'
            });

            if (this.currentSpace.companyId) {
              this.$router.push('/company-space/contracts?status=all')
            } else {
              this.$router.push('/user-space/contracts?status=all')
            }
          } else {

            if (isFirst) {
              if (firstSignatory.signingBody == '0') { // 签署主体为个人
                this.$router.push({
                  path: '/set-control',
                  query: {
                    contractId: res.data.contractId,
                    isFirst: 'true',
                    isSame: isSame
                  }
                })
              } else {
                this.$router.push({
                  path: '/set-control',
                  query: {
                    contractId: res.data.contractId,
                    isFirst: 'true',
                    companyId: this.currentSpace.companyId,
                    isSame: isSame
                  }
                })
              }
            } else {
              this.$router.push({
                path: '/set-control',
                query: {
                  contractId: res.data.contractId
                }
              })
            }
          }
        }
      })
    }
  },
}
</script>
<style>
#flow-layer .el-table .cell {
  padding: 0 20px;
  font-size: 14px;
}

#flow-layer .el-table tr {
  height: 72px;
}

#flow-layer .el-table th>.cell {
  font-size: 16px;
}

.hide .el-upload--picture-card {
  display: none;
}

#flow-layer .el-loading-spinner {
  height: 166px;
  margin-top: -43px;
}
</style>

<style scoped>
#flow-layer {
  background: #f0f0f5;
  min-height: 100vh;
}

header {
  width: 100%;
  height: 71px;
  background: rgba(35, 43, 58, 1);
  box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
  line-height: 71px;
  overflow: hidden;
}

.header-center {
  width: 1200px;
  margin: 0 auto;
  line-height: 71px;
  height: 71px;
  overflow: hidden;
  position: relative;
}

.logo {
  margin-top: 16px;
  margin-left: 0;
  width: 126px;
  float: left;
}

.logo-text {
  margin-left: 42px;
  font-size: 24px;
  color: #ffffff;
}

.logo-s-title {
  font-size: 24px;
  color: #ffffff;
  margin-left: 24px;
}

.return-index {
  height: 71px;
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 24px;
  color: #ffffff;
  line-height: 71px;
}

.flow-nav-layer {
  /* width: 10000000px; */
  height: 43px;
}

.flow-content {
  width: 1200px;
  margin: 30px auto;
}

.flow-nav {
  width: 1200px;
  height: 54px;
  overflow: hidden;
  line-height: 42px;
  color: #333333;
  font-size: 16px;
  overflow-x: auto;
}

.flow-nav a {
  display: block;
  float: left;
  width: 139px;
  height: 43px;
  overflow: hidden;
  padding: 0 18px;
  margin-right: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: #E5E5E5;
  text-align: center;
}

.flow-nav a:last-child {
  margin-right: 0;
}

.flow-nav a.active {
  background: #ffffff;
}

.flow-files {
  width: 1200px;
  background: #ffffff;
  overflow: hidden;
}

.flow-title {
  height: 23px;
  line-height: 23px;
  font-size: 18px;
  color: #333333;
  border-left: 3px solid #E85052;
  text-indent: 10px;
  margin-top: 31px;
  margin-left: 27px;
  font-weight: 400;
}

.flow-upload {
  width: 148px;
  height: 148px;
  margin: 28px auto 0;
  overflow: hidden;
}

.upload-tip {
  position: relative;
  top: -120px;
  font-size: 14px;
  color: #999999;
}

.upload-tip2 {
  text-align: center;
  font-size: 14px;
  color: #D75C57;
  margin-top: 20px;
}

.upload-progress {
  width: 320px;
  margin: 10px auto 0;
}

.progress-title {
  font-size: 14px;
  color: #606266;
  float: left;
}

.progress-box {
  width: 320px;
  /* float: right; */
  margin-right: -30px;
  margin-top: 4px;
}

.files-form-box {
  width: 320px;
  margin: 26px auto 0;
}

.flow-users-box {
  width: 1120px;
  padding: 0 40px;
  background: #ffffff;
  margin-top: 18px;
  overflow: hidden;
}

.add-user-btns {
  margin-top: 22px;
}

.add-btn {
  background: #E85052;
  color: #ffffff;
  height: 36px;
  font-size: 14px;
}

.signatory-list {
  margin-top: 23px;
  width: 1120px;
}

.signatory-item {
  box-sizing: border-box;
  width: 1120px;
  height: 130px;
  border: 2px dashed rgba(240, 240, 245, 1);
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 15px;
  padding: 0 20px;
  position: relative;
}

.signatory-item-title {
  margin: 16px 0 0 0;
  font-size: 16px;
  color: #000000;
  font-weight: bold;
  line-height: 16px;
}

.signatory-form {
  margin-top: 10px;
}

.signatory-form-item {
  width: 165px;
  float: left;
  margin-right: 66px;
}

.signatory-form-item-title {
  font-size: 14px;
  color: #333333;
  margin-bottom: 10px;
}

.signatory-form-item-inp {
  font-size: 14px;
  color: #666666;
  line-height: 40px;
  position: relative;
}

.signatory-delete {
  right: 20px;
  top: 50%;
  margin-top: -12px;
  position: absolute;
  cursor: pointer;
}

.signatory-batch,
.signatory-batch-success {
  box-sizing: border-box;
  width: 1120px;
  height: 180px;
  border: 2px dashed rgba(240, 240, 245, 1);
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 15px;
  padding: 0 20px;
  position: relative;
}

.signatory-batch-content {
  margin-top: 20px;
}

.signatory-batch-item {
  height: 20px;
  line-height: 20px;
  margin-bottom: 15px;
}

.step {
  float: left;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  text-align: center;
  color: #ffffff;
  background: #E85052;
  margin-right: 10px;
}

.step-cont {
  font-size: 14px;
  color: #666666;
}

.download-template {
  color: #D75C57;
}

.upload-template {
  height: 36px;
  /* background: #E85052; */
  color: #ffffff;
  margin-top: -5px;
  margin-left: 15px;
  width: 98px;
  float: left;
  overflow: hidden;
}

.signatory-batch-content2 {
  margin-top: 39px;
  margin-left: 40px;
  font-size: 14px;
  color: #666666;
}

.signatory-batch-text {
  margin-bottom: 28px;
}

.show-signatory {
  color: #E25658;
  margin-right: 5px;
}

.mail-icon {
  display: block;
  width: 25px;
  position: absolute;
  right: 5px;
  top: 8px;
  z-index: 999;
  cursor: pointer;
}

.sign-btns {
  width: 718px;
  margin: 40px auto 0;
  display: flex;
  justify-content: space-between;
  padding-bottom: 40px;

}

.sign-btns button {
  width: 149px;
  height: 50px;
  font-size: 16px;
}

.sign-btns button:hover {
  background: #ffffff;
  color: #606266;
  border-color: #DCDFE6;
}

.sign-btns button.sign-button {
  background: #D75C57;
  color: #ffffff;
  border-color: #D75C57;
}
</style>
